import { api } from '@mc/legacy-api'
import { Links, ShareLinkResponse } from './types'

type OptionalRecordWithId = { id?: string | number | null }

type LinkSource = {
  course?: OptionalRecordWithId | null
  chapter?: OptionalRecordWithId | null
  source?: string | null
  gem?: OptionalRecordWithId | null
  recipe?: OptionalRecordWithId | null
  article?: OptionalRecordWithId | null
}

const getShareableLinks = async (
  { course, source, chapter, gem, recipe, article }: LinkSource = {},
  isLessonShare = false,
) => {
  const attributes = {
    ...(article && { article_id: article.id }),
    ...(course && { course_id: course.id }),
    ...(chapter && isLessonShare && { chapter_id: chapter.id }),
    ...(source && { source }),
    ...(gem && { immersive_hero_id: gem.id }),
    ...(recipe && { recipe_id: recipe.id }),
  }

  const response = (await api.post(
    '/jsonapi/v1/shares',
    attributes,
  )) as ShareLinkResponse
  const { invitationLinks = [] } = response
  const shareableLinks: Record<string, string | undefined> = {}

  invitationLinks.forEach(({ content, url }) => {
    shareableLinks[content.toLowerCase()] = url
  })

  return shareableLinks as Links
}

export default getShareableLinks
